import { createSlice } from '@reduxjs/toolkit';
import { authApiSlice } from './authApiSlice';

const user = JSON.parse(sessionStorage.getItem('user'));

const initialState = {
  user: user ? user : null,
  token: user ? user.access : null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      sessionStorage.removeItem('user');
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      authApiSlice.endpoints.login.matchFulfilled,
      (state, { payload }) => {
        state.token = payload.access;
        state.user = payload;
        sessionStorage.setItem('user', JSON.stringify(payload));
      }
    );
  },
});

export const { logout } = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentUser = (state) => state.auth.user;
export const selectCurrentToken = (state) => state.auth.token;
